module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('span', {
    staticClass: "bb"
  }, [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/08_ListofIll"
    }
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Acknowledgement"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Prologue"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Part01"
    }
  }, [_c('b', [_c('span', {
    staticClass: "bb"
  }, [_vm._v("Part I")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14_Chapter01"
    }
  }, [_c('i', [_vm._v("Chapter 1")]), _c('br'), _vm._v("The British Violate Their Terms and Rule by Edict")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 2")]), _c('br'), _vm._v("A Proud and Haughty Scot Takes Command of Charleston")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 3")]), _c('br'), _vm._v("A Fierce and Unrelenting Soldier Comes in from the Field")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "bb"
  }, [_vm._v("Part II")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 4")]), _c('br'), _vm._v("“I do not mean to desert the cause of America”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 5")]), _c('br'), _vm._v("The Captor Becomes the Captive")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 6")]), _c('br'), _vm._v("“The imminent and shocking doom of the most unfortunate Mr. Hayne”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 7")]), _c('br'), _vm._v("“We seriously lament the necessity of such a severe expedient”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "bb"
  }, [_vm._v("Part III")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 8")]), _c('br'), _vm._v("Rawdon’s Fantastic Shipboard Recollections")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 9")]), _c('br'), _vm._v("“In South Carolina no one even knows where he is buried”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 10")]), _c('br'), _vm._v("A Survey of the Story of Isaac Hayne in Art and Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix A")]), _c('br'), _vm._v("The Proclamations of Lt. Gen. Sir Henry Clinton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Appendix02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix B")]), _c('br'), _vm._v("The Correspondence between Col. Isaac Hayne and His British Captors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Appendix03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix C")]), _c('br'), _vm._v("John Colcock’s Legal Brief: “Case of Colonel Hayne”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Appendix04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix D")]), _c('br'), _vm._v("Ladies’ Petition for Colonel Isaac Hayne")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Index01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70dd2ec0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Contents.vue
// module id = 75
// module chunks = 0